import React from 'react'
import styled from 'styled-components'
import I18n from 'i18n-js'
import { translate } from '../services/i18n'

const Bar = styled.div`
    color: white;
    box-sizing: border-box;
    width: 100%;
    background-color: #373847ee;
    padding: 20px;

    h1 {
        font-size: 24px;
        margin: 0;
    }

    p {
        font-size: 14px;
        margin-bottom: 0;
    }
`

const PeriodHeader = styled.h2`
    font-size: 18px;
    margin: 6px 0 4px 0;
    opacity: 0.9;
    font-weight: 600;
`

const PolicyNote = styled.p`
    font-size: 12px !important;
    opacity: 0.6;
    margin-top: 4px !important;
`

// Dia 1 antes do meio-dia UTC-3 → mês anterior; caso contrário → mês atual
function getRankingPeriod() {
    const now = new Date();
    const utcMinus3 = new Date(now.getTime() - 3 * 60 * 60 * 1000);
    const day = utcMinus3.getUTCDate();
    const hours = utcMinus3.getUTCHours();
    let year = utcMinus3.getUTCFullYear();
    let month = utcMinus3.getUTCMonth();
    if (day === 1 && hours < 12) {
        if (month === 0) { month = 11; year -= 1; }
        else { month -= 1; }
    }
    return new Date(year, month, 1);
}

const Navbar = () => {
    const periodDate = getRankingPeriod();
    const intlLocale = I18n.locale === 'pt_BR' ? 'pt-BR' : 'en-US';
    const formattedPeriod = new Intl.DateTimeFormat(intlLocale, { month: 'long', year: 'numeric' }).format(periodDate);
    const capitalizedPeriod = formattedPeriod.charAt(0).toUpperCase() + formattedPeriod.slice(1);

    return (
        <Bar>
            <h1>{translate('header.title', { server: 'Global' })}</h1>
            <PeriodHeader>{capitalizedPeriod}</PeriodHeader>
            <p>{translate("header.description")}</p>
            <p>{translate('header.description2')}</p>
            <PolicyNote>{translate('header.updatePolicy')}</PolicyNote>
        </Bar>
    )
}

export default Navbar
